<div class="irrigation">

  <!-- Currently running scenario -->
  <div class="card running" *ngIf="running; else idleBlock">
    <div class="card-title">
      <span class="dot pulse"></span> {{ 'irrigation.watering_now' | translate }}
    </div>
    <div class="phase">
      <span class="phase-name">{{ running.phaseLabel }}</span>
      <span class="phase-step">{{ 'irrigation.phase_step' | translate: { step: running.stepIndex, total: running.totalSteps } }}</span>
    </div>
    <div class="scenario-name">{{ running.scenarioName }}</div>
    <div class="times">
      <div>
        <span class="label">{{ 'irrigation.phase_ends_in' | translate }}</span>
        <span class="value">{{ fmtDur(secsLeft(running.phaseEndTime)) }}</span>
      </div>
      <div>
        <span class="label">{{ 'irrigation.finishes_at' | translate }}</span>
        <span class="value">{{ running.endTime | date: 'HH:mm' }}</span>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar"
           [style.width.%]="running.totalSteps ? (running.stepIndex / running.totalSteps) * 100 : 0"></div>
    </div>
  </div>

  <ng-template #idleBlock>
    <div class="card idle">
      <div class="card-title"><span class="dot"></span> {{ 'irrigation.idle' | translate }}</div>
      <div class="muted">{{ 'irrigation.no_scenario' | translate }}</div>
    </div>
  </ng-template>

  <!-- Next scheduled run -->
  <div class="card next">
    <div class="card-title">{{ 'irrigation.next_run' | translate }}</div>
    <ng-container *ngIf="nextRun; else noNext">
      <div class="next-scenario">{{ nextRun.scenarioName }}</div>
      <div class="next-when">{{ nextRun.when | localizedDate: 'EEE, dd MMM, HH:mm' }}</div>
    </ng-container>
    <ng-template #noNext>
      <div class="muted">{{ 'irrigation.nothing_scheduled' | translate }}</div>
    </ng-template>
  </div>

  <!-- Skip today -->
  <div class="card skip">
    <label class="skip-row">
      <input type="checkbox" [checked]="skipToday" (change)="onSkipToggle($event)" />
      <span>
        <span class="skip-title">{{ 'irrigation.skip_today' | translate }}</span>
        <span class="skip-sub">{{ 'irrigation.skip_today_hint' | translate }}</span>
      </span>
    </label>
  </div>

  <!-- Buttons (scenarios are usually bound to these) -->
  <div class="card buttons" *ngIf="hasButtons">
    <div class="card-title">{{ 'controller.tab.buttons' | translate }}</div>
    <div class="buttons-grid">
      <ng-container *ngFor="let group of buttonGroupList; trackBy: trackByGroupKey">
        <app-button-card *ngFor="let btn of group.value; trackBy: trackByButton"
                         [input]="btn"
                         [mac]="controller?.mac"
                         [node]="btn.node">
        </app-button-card>
      </ng-container>
    </div>
  </div>

</div>
